export function LetterTile({ letter, active, done, testId }) {
  if (letter === " ")
    return <span className="wmleye-letter wmleye-letter--space" aria-hidden />;
  return (
    <span
      className={`wmleye-letter${active ? " wmleye-letter--active" : ""}${done ? " wmleye-letter--done" : ""}`}
      data-testid={testId}
      aria-hidden={!active}
    >
      {letter}
    </span>
  );
}

export function SpellingRibbon({ letters, activeIndex, doneUpTo }) {
  if (!letters || !letters.length) return null;
  return (
    <div
      className="wmleye-spelling"
      role="group"
      aria-label={`Spelling: ${letters.join(" ")}`}
      data-testid="spelling-ribbon"
    >
      {letters.map((l, i) => (
        <LetterTile
          key={i}
          letter={l}
          active={i === activeIndex}
          done={i < doneUpTo}
          testId={`letter-tile-${i}`}
        />
      ))}
    </div>
  );
}
